import { FILTER_DISPLAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";

export const CHART_TYPES = [
  { name: "Barras", value: "bar" },
  { name: "Barras horizontales", value: "horizontal-bar" },
  { name: "Dona", value: "doughnut" },
  { name: "Línea", value: "line" },
  { name: "Torta", value: "pie" }
];

export const NOTIFICATION_TEMP_CONSTANTS = {
  CANCEL_BTN: "Cancelar",
  CATEGORIES: ["NEW", "OTHER"],
  CHANNELS: ["WHATSAPP"],
  DEFAULT_CHANNEL: "WHASTAPP",
  DEFAULT_TYPE: "TEXT",
  EDITING_TITLE: "Editar plantilla",
  FIELD: "Campo",
  FORM_NAME: "Nombre formulario",
  ICON_ADD: "mdi-plus-circle-outline",
  ICON_CANCEL: "mdi-undo",
  OPTIONS_PANEL: [
    {
      value: "showAddList",
      srcImg: "search.png",
      name: "Agregar Lista"
    }
  ],
  PAGE_TITLE_SEARCH: "Consulta plantillas de Notificaciones",
  PAGE_TITLE: "Notificaciones",
  PREVIEW: "Vista previa",
  PREVIEW_USER_MESSAGE: "Mensaje de usuario",
  SYNC_TEMP: "Sincronizar Templates",
  TOOLTIP: "Cambiar gráfica",
  TOOLTIP_ADD_BTN: "Crear formulario",
  TOOLTIP_CANCEL_BTN: "Cancelar",
  TYPES: ["VIDEO", "IMAGES", "DOCUMENT", "TEXT"],
  UPDATE_BTN: "Actualizar template",
  UPDATE_TEMP: "Actualizar template",
  CANCEL_UPDATE: "Cancelar actualización",
  NAME: "Nombre",
  OTHER: "OTRA",
  CHANNEL_LABEL: "Canal",
  CATEGORIES_LABEL: "Categorias",
  TYPE_LABEL: "Tipo",
  CARD_DESCRIPTIONS: ["appChannel", "appCategory", "appType"],
  ADD_CATEGORY: "Agregar categoría",
  ADD_CHANNEL: "Agregar canal",
  ADD_TYPE: "Agregar tipo"
};

export const NOTIFICATION_TEMP_MESSAGES = {
  ERROR_LOADING_DATA:
    "Error obteniendo plantillas, por favor inténtelo más tarde",
  ERROR_UPDATING: "Error actualizando template, por favor inténtelo más tarde.",
  ERROR_FETCHING_DETAILS:
    "Error obteniendo template, por favor intentelo más tarde",
  ERROR: "Error interno, por favor intentelo más tarde",
  ERROR_DISABLING_TEMP:
    "Error deshabilitando template, por favor intentelo más tarde",
  NO_TEMPLATES: "No se han encontrado templates",
  NO_DOCUMENT_TEMPLATE: "Este template no cuenta con documento",
  ITEM_NOT_EXISTS: (item: string) =>
    `El item ${item} ya existe, por favor intente con uno diferente`
};

export const DOCUMENT_SECONDARY_FILTERS: SecondaryFilter[] = [
  {
    name: "Nombre",
    key: "name",
    type: "secondaryFilter",
    display: FILTER_DISPLAY.UNIQUE,
    default: true,
    operators: OPERATORS_FILTERS,
    avatar: "mdi-form-textbox",
    disabled: false
  },
  {
    name: "Canal",
    key: "channel",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: []
  },
  {
    name: "Categoria",
    key: "category",
    avatar: "mdi-shape",
    type: "secondaryFilter",
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: []
  },
  {
    name: "Tipo",
    key: "type",
    avatar: "mdi-shape",
    type: "secondaryFilter",
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: []
  },
  {
    name: "Estado",
    key: "state",
    avatar: "mdi-list-status",
    type: "secondaryFilter",
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: [
      { name: "Activo", key: "Activo" },
      { name: "Inactivo", key: "Inactivo" }
    ]
  }
];

export const FORM_FILTERS_LIST: Filter[] = [
  {
    mainFilterKey: "all",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    secondaryFilters: DOCUMENT_SECONDARY_FILTERS,
    initial: true,
    placeholder:
      "Escriba el nombre de la plantilla o utiliza los filtros para agrupar información"
  }
];

export const EMIT_EVENTS = {
  SHOW_NOTIFICATION_TEMPLATE: "showNotificationTemplate",
  MODAL_SAVE: "modalSave"
};

export const MODAL_MESSAGES = {
  TITLE: "Edición lista"
};

export const LISTS_NAMES = {
  CHANNEL: "Canales Whatsapp",
  CATEGORY: "Categorias Whatsapp",
  TYPE: "Tipos Whatsapp"
};

export const NOTIFICATION_ACCESS = {
  GET: "consultar plantillas de notificacion",
  POST: "crear plantillas de notificacion",
  PUT: "modificar plantillas de notificacion",
  DELETE: "eliminar plantillas de notificacion"
};

export const WHATSAPP_TEMPLATE_CHART_NAMES = {
  CHANNEL: "Canales",
  CATEGORY: "Categorías",
  TYPE: "Tipos"
};

export const WHATSAPP_TEMPLATE_CHART_PARAM = {
  CHANNEL: "appChannel",
  CATEGORY: "appCategory",
  TYPE: "appType"
};

export const TEMPLATE_CATEGORY_CONFIG: DynamicSelectConfig = {
  multiple: true,
  default: [],
  listAll: [],
  messageLabel: NOTIFICATION_TEMP_CONSTANTS.CATEGORIES_LABEL,
  hint: "",
  persistenthint: false,
  required: true,
  chips: true,
  disabled: false,
  showModalAdd: "addCategory",
  persistentAddButton: true
};

export const TEMPLATE_TYPE_CONFIG: DynamicSelectConfig = {
  multiple: false,
  default: [],
  listAll: [],
  messageLabel: NOTIFICATION_TEMP_CONSTANTS.TYPE_LABEL,
  hint: "",
  persistenthint: false,
  required: true,
  chips: false,
  disabled: true,
  showModalAdd: "addType",
  persistentAddButton: true
};

export const TEMPLATE_CHANNEL_CONFIG: DynamicSelectConfig = {
  multiple: false,
  default: [],
  listAll: [],
  messageLabel: NOTIFICATION_TEMP_CONSTANTS.CHANNEL_LABEL,
  hint: "",
  persistenthint: false,
  required: true,
  chips: false,
  disabled: true,
  showModalAdd: "addChannel",
  persistentAddButton: true
};
